const angular_imag1 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/an1-ecom.gif"
const angular_imag2 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/an2-ecom.gif"
const angular_imag3 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/an3-ecom.gif"

// const bewa1 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/bewa1.png"
// const bewa2 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/bewa2.gif"
// const bewa3 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/bewa3.gif"


const l1 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/lms_a1.png"
const l2 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/lms_a2.gif"
const l3 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/lms_a3.gif"


// const myShop1 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/myShop1.gif"
// const myShop2 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/myShop2.gif"
// const myShop3 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/myShop3.gif"


// const duk1 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/dukan3.gif"
// const duk2 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/dukan2.gif"
// const duk3 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/dukan1.gif"


const you1 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/you1.png"
const you2 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/you2.gif"
const you3 = "https://api.ahatechnocrats.com/wp-content/uploads/2021/05/you1.png"



const projectsData = [
    {
        images: [angular_imag1, angular_imag2, angular_imag3],
        title: "Angular E-Comm",
        description: "This is an e-commerce application that incorporates various features such as user authentication, product management and  more...",
        techStack: "Angular",
        gitHubLink: "https://github.com/alalUDDIN123/angular_ecom",
        deployedLink: "https://angular-e-com.netlify.app/"
    },
    // {
    //     images: [bewa1, bewa2, bewa3],
    //     title: "Bewakoof.com",
    //     description: "Bewakoof.com is leading E-Commerce web application which provides wide range of Men and Women Clothing",
    //     techStack: "Html , Css , JavaScript",
    //     gitHubLink: "https://github.com/alalUDDIN123/Bewakoof.com?organization=alalUDDIN123&organization=alalUDDIN123",
    //     deployedLink: "https://astonishing-kitten-4d475f.netlify.app/"
    // }

    // {
    //     images: [myShop1, myShop2, myShop3],
    //     title: "My Shopping",
    //     description: "MyShopping.com is an online e-commerce site where users can buy various type of products",
    //     techStack: "NodeJS , Express JS , MongoDB , React",
    //     gitHubLink: "https://github.com/alalUDDIN123/my_shoping",
    //     deployedLink: "https://my-shoping-frontend.vercel.app/"
    // },
    {
        images: [l1, l2, l3],
        title: "Learning Management",
        description: "This is one of the best project that I have made. There are two main persons. One is Admin and another Student",
        techStack: "JavaScript , Html , Css",
        gitHubLink: "https://github.com/alalUDDIN123/Learning-Managment-System",
        deployedLink: "https://learning-managment-system.netlify.app"
    },
    // {
    //     images: [duk1, duk2, duk3],
    //     title: "Dukaan.in",
    //     description: "Dukaan.in is an online e-Commerce website where user can buy various type of products based on their interest.",
    //     techStack: "NodeJS , Express JS , MongoDB , React",
    //     gitHubLink: "https://github.com/alalUDDIN123/steady-roll-4006",
    //     deployedLink: "https://frontend-seven-red-58.vercel.app/"
    // },
    {
        images: [you1, you2, you3],
        title: "YouTube Clone",
        description: "This is a mini You Tube app build within 2 days . By default most popular video shows here.",
        techStack: "Html , Css , JavaScript",
        gitHubLink: "https://github.com/alalUDDIN123/You-Tube-Mini-App",
        deployedLink: "https://youtubeminiapp.vercel.app/"
    },
]

export { projectsData }